import { createFileRoute, Link } from "@tanstack/react-router";
import { Heart, Camera, CalendarPlus, ShieldCheck, Share2, Facebook, Mail } from "lucide-react";

export const Route = createFileRoute("/review/$token/thanks")({
  head: () => ({ meta: [{ title: "Thank you — Michael's Painting" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: ThanksPage,
});

const ACTIONS = [
  { to: "/contact", label: "Refer a Friend", desc: "Earn a thank-you when they hire us.", icon: Heart, search: { topic: "referral" } as any },
  { to: "/gallery", label: "View Before & After", desc: "Browse our transformations.", icon: Camera },
  { to: "/estimate", label: "Schedule Another Project", desc: "Free instant range in 60 seconds.", icon: CalendarPlus },
  { to: "/portal/warranty", label: "Download Warranty", desc: "Your 3-year written warranty.", icon: ShieldCheck },
];

function ThanksPage() {
  return (
    <div className="min-h-screen bg-[#030303] text-white px-5 py-16">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <p className="text-[10px] uppercase tracking-[0.3em] text-amber-300 font-semibold">Michael's Painting</p>
        <h1 className="font-serif text-3xl md:text-5xl mt-3">Thank you — we really appreciate it.</h1>
        <p className="text-zinc-400 mt-4 max-w-xl mx-auto">Your support helps a local craftsman business grow. Here are a few ways to stay connected.</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-4 max-w-3xl mx-auto">
        {ACTIONS.map((a) => {
          const Icon = a.icon;
          return (
            <Link key={a.label} to={a.to as any} className="flex items-start gap-4 p-5 rounded-2xl border border-white/10 bg-white/[0.03] hover:border-amber-300/30 transition">
              <Icon className="size-6 text-amber-300 shrink-0" />
              <div>
                <p className="font-semibold text-white">{a.label}</p>
                <p className="text-xs text-zinc-400 mt-1">{a.desc}</p>
              </div>
            </Link>
          );
        })}
      </div>
      <div className="max-w-3xl mx-auto mt-6 grid sm:grid-cols-3 gap-3">
        <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 p-4 rounded-2xl border border-white/10 bg-white/[0.02] text-sm hover:border-amber-300/30">
          <Facebook className="size-4 text-amber-300" /> Follow on Facebook
        </a>
        <Link to="/contact" className="flex items-center justify-center gap-2 p-4 rounded-2xl border border-white/10 bg-white/[0.02] text-sm hover:border-amber-300/30">
          <Mail className="size-4 text-amber-300" /> Join our email list
        </Link>
        <Link to="/gallery" className="flex items-center justify-center gap-2 p-4 rounded-2xl border border-white/10 bg-white/[0.02] text-sm hover:border-amber-300/30">
          <Share2 className="size-4 text-amber-300" /> Share before & after
        </Link>
      </div>
      <p className="text-center text-xs text-zinc-500 mt-12">— Michael &amp; the team</p>
    </div>
  );
}
